document.querySelectorAll('.denim-lp-size-finder').forEach(function (root) {
  var dataEl = root.querySelector('[data-denim-lp-size-finder-data]');
  if (!dataEl) return;
  var data;
  try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }

  var waistEl = root.querySelector('[data-denim-lp-waist]');
  var inseamEl = root.querySelector('[data-denim-lp-inseam]');
  var fabGroup = root.querySelector('[data-denim-lp-fab-group]');
  var resultEmpty = root.querySelector('[data-denim-lp-result-empty]');
  var resultFilled = root.querySelector('[data-denim-lp-result-filled]');
  var fabNameLabel = root.querySelector('[data-denim-lp-fabname]');
  var sizeLabelEl = root.querySelector('[data-denim-lp-size-label]');
  var ticketMetaEl = root.querySelector('[data-denim-lp-ticket-meta]');
  var fabSpecEl = root.querySelector('[data-denim-lp-fab-spec]');
  var whyLabelEl = root.querySelector('[data-denim-lp-why-label]');
  var fabNoteEl = root.querySelector('[data-denim-lp-fab-note]');
  var ctaLabelEl = root.querySelector('[data-denim-lp-cta-label]');
  var liveTextEl = root.querySelector('[data-denim-lp-live-text]');
  if (!waistEl || !inseamEl || !fabGroup || !resultEmpty || !resultFilled) return;

  var fabKeys = Object.keys(data.fabrics);
  var state = { fab: fabKeys[0] };

  var clamp = function (n, min, max) { return Math.min(max, Math.max(min, n)); };

  var recalc = function () {
    var f = data.fabrics[state.fab];
    if (!f) return;
    var waist = parseFloat(waistEl.value);
    var waistMin = parseFloat(waistEl.min) || 23;
    var waistMax = parseFloat(waistEl.max) || 36;
    var inseam = inseamEl.value;
    var ok = !!(waist && waist >= waistMin && waist <= waistMax && inseam);

    fabNameLabel.textContent = f.name;

    if (ok) {
      var size = clamp(Math.round(waist) + f.adj, 24, 32);
      resultEmpty.hidden = true;
      resultFilled.hidden = false;
      resultFilled.classList.remove('is-stamped');
      void resultFilled.offsetWidth;
      resultFilled.classList.add('is-stamped');

      sizeLabelEl.textContent = size + '/' + inseam;
      ticketMetaEl.textContent = f.name + ' · measured waist ' + waist + '″';
      fabSpecEl.textContent = f.spec;
      whyLabelEl.textContent = 'Why ' + size + ':';
      fabNoteEl.textContent = f.note;
      ctaLabelEl.innerHTML = '<span class="denim-lp-cta__text">' + data.ctaVerb + ' ' + f.name + ' in ' + size + '/' + inseam + '</span>';
      if (liveTextEl) liveTextEl.textContent = 'Your size in ' + f.name + ' is ' + size + ' by ' + inseam + '.';
    } else {
      resultEmpty.hidden = false;
      resultFilled.hidden = true;
      if (liveTextEl) liveTextEl.textContent = '';
    }
  };

  waistEl.addEventListener('input', recalc);
  inseamEl.addEventListener('change', recalc);

  fabGroup.querySelectorAll('.denim-lp-size-finder__fab-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      fabGroup.querySelectorAll('.denim-lp-size-finder__fab-btn').forEach(function (b) {
        b.classList.remove('is-selected');
        b.setAttribute('aria-pressed', 'false');
      });
      btn.classList.add('is-selected');
      btn.setAttribute('aria-pressed', 'true');
      state.fab = btn.getAttribute('data-fab');
      recalc();
    });
  });
});
